// Two emotion caches on purpose. MUI's is prepended to head, tss-react's is appended,
// so component styles come later in the document and win ties against theme overrides
// from styles/components.js. With a single shared cache the order depends on render
// order and theme overrides start winning — that is what @mui/styles used to prevent by
// keeping JSS sheets after emotion.
// Both caches carry the CSP nonce: without it a strict style-src blocks every <style>
// emotion injects at runtime.
import React from 'react';
import { CacheProvider } from '@emotion/react';
import { TssCacheProvider } from 'tss-react';
import createCache from '@emotion/cache';

const nonce = document
  .querySelector('meta[property="csp-nonce"]')
  ?.getAttribute('content');

const muiCache = createCache({
  key: 'mui',
  prepend: true,
  nonce: nonce || undefined,
});

const tssCache = createCache({
  key: 'tss',
  nonce: nonce || undefined,
});

const StyleProvider = ({ children }) => (
  <CacheProvider value={muiCache}>
    <TssCacheProvider value={tssCache}>{children}</TssCacheProvider>
  </CacheProvider>
);

export default StyleProvider;
